// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e8de190","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/elements/sampleStatus.vue
// module id = 5Jvp
// module chunks = 1